import ShopgateTrackingTrustedTrackingSubscriber from '@shopgate/tracking-trusted/frontend/subscriptions/index.js';
import ShopgateAuthFacebookSubscriber from '@shopgate/auth-facebook/frontend/subscriptions/index.js';
import ShopgateStorefrontStorefrontSubscribers from '@shopgate/storefront/frontend/subscribers/index.js';
import ShopgateConnectDualStackSyncPushMessageSubscription from '@shopgate/connect/frontend/subscribers.js';
import ShopgateConnectTrustedExternalLoginSubscription from '@shopgate/connect-trusted/frontend/ExternalLogin/subscribers.js';
import ShopgateConnectTrustedGuestCheckoutSubscription from '@shopgate/connect-trusted/frontend/GuestCheckout/subscribers.js';

export default [
  ShopgateTrackingTrustedTrackingSubscriber,
  ShopgateAuthFacebookSubscriber,
  ShopgateStorefrontStorefrontSubscribers,
  ShopgateConnectDualStackSyncPushMessageSubscription,
  ShopgateConnectTrustedExternalLoginSubscription,
  ShopgateConnectTrustedGuestCheckoutSubscription,
];
